import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';
import toast from 'react-hot-toast';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { TypeAnimation } from 'react-type-animation';
import './ContactSection.css';


const ContactSection = () => {


    const form = useRef();

    const handleSubmit = (e) => {
        e.preventDefault();


        emailjs.sendForm('service_kpmq42l', 'template_j6gf3lj', form.current, 'jTQI10-ZBoJ-bZXo_')
            .then((result) => {
                console.log(result.text);
                toast.success('Thanks your for your message!!. We will reply in your email shortly!!!')
                e.target.reset()
            }, (error) => {
                console.log(error.text);
            });
    };


    return (
        <div className='max-w-7xl mx-auto px-6 pt-20'>
            <div className='text-center mb-20'>
                <h3 className="text-xs md:text-sm xl:text-md font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">contact</h3>
                <h1 className='text-5xl md:text-6xl xl:text-7xl font-bold'>Contact With Me</h1>
            </div>

            <div className='grid lg:grid-cols-5 gap-10 mx-5'>
                <div className=' box col-span-1 lg:col-span-2  shadow-slate-600 rounded-lg shadow-lg'>
                    <div className="shadow-xl">
                        <figure className="px-8 pt-8 ">

                            <img src="https://i.ibb.co/dD7d8Kj/shijan.jpg" alt="MyPhoto" className=" w-full rounded-xl brightness-90" />

                        </figure>
                        <div className="card-body ">
                            <h2 className="text-3xl font-bold text-[#D2E6EA]">Md Shijan Ali</h2>
                            <h3 className='text-xl font-semibold  text-[#ff014f]'>(
                                <TypeAnimation
                                    // Same String at the start will only be typed once, initially
                                    sequence={[
                                        ' Professional MERN Stack Developer',
                                        2000,
                                        ' Professional MEVN Stack Developer',
                                        2000,
                                        ' Junior Web Developer',
                                        2000,
                                        ' Junior Software Engineer',
                                        2000,
                                        ' Software Engineer',
                                        2000,
                                        ' Front End Developer',
                                        2000,
                                        ' Web Developer',
                                        2000,
                                        ' WordPress Developer',
                                        2000,
                                    ]}
                                    speed={0} // Custom Speed from 1-99 - Default Speed: 40

                                    wrapper="span" // Animation will be rendered as a <span>
                                    repeat={Infinity} // Repeat this Animation Sequence infinitely
                                />
                                )</h3>
                            <p className='text-lg text-[#878E99] '>I'm Available for Job, Internship or Freelance Work. Contact with me via email and call in to my WhatsApp</p>


                            <p className="text-xl text-[#878E99] mt-3 relative w-max one">Phone:
                                <a className='text-[#D2E6EA] cursor-pointer' href="tel:+8801571261165"> +880 1571261165 </a>
                                <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                            </p>

                            <p className="text-xl text-[#878E99] w-max relative  one">Email:
                                <a className='text-[#D2E6EA] cursor-pointer' href="mailto:shijan135@gmail.com"> shijan135@gmail.com </a>
                                <span className="absolute -bottom-1 left-0 w-0 transition-all h-[1px] bg-[#ff014f]"></span>
                            </p>


                            <div>
                                <h3 className='text-md tracking-wide my-4 text-[#878E99]'>FIND WITH ME</h3>
                                <div className=' flex gap-6'>
                                    <div className=' shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                                        <a href="https://facebook.com/mdshijanali135" target='_blank' rel="noreferrer"><FaFacebookF className='w-6 h-6 text-[#BBC6D4] hover:text-[#ff014f]'></FaFacebookF></a>
                                    </div>
                                    <div className='shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                                        <a href="https://twitter.com/shijan135" target='_blank' rel="noreferrer"><FaTwitter className='w-6 h-6 text-[#BBC6D4] hover:text-[#ff014f]'></FaTwitter></a>
                                    </div>
                                    <div className='shadow-lg shadow-slate-600 p-4 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300'>
                                        <a href="https://linkedin.com/in/mdshijanali" target='_blank' rel="noreferrer"><FaLinkedinIn className='w-6 h-6 text-[#BBC6D4] hover:text-[#ff014f]'></FaLinkedinIn></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='box lg:col-span-3 shadow-slate-600 rounded-lg shadow-lg'>
                    <section>
                        <h2 className='text-center mt-16 mb-10 text-5xl md:text-4xl xl:text-5xl font-bold text-[#D2E6EA]'>Send Message</h2>

                        <div className="p-6 sm:p-10">

                            <form ref={form} onSubmit={handleSubmit}>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4">
                                    <div>
                                        <label htmlFor="name" className="text-base font-medium text-[#878E99]"> Your name </label>
                                        <div className="mt-2.5 relative">
                                            <input type="text" name="name" id="name" placeholder="" className="block w-full px-4 py-4 text-[#878E99]  transition-all duration-200 border-2 border-black rounded-md bg-[#191B1E]  focus:border-[#ff014f] focus:bg-[#191B1E] " required />
                                        </div>
                                    </div>

                                    <div>
                                        <label htmlFor="phone" className="text-base font-medium text-[#878E99]"> Phone number </label>
                                        <div className="mt-2.5 relative">
                                            <input type="number" name="phone" id="phone" placeholder="" className="block w-full px-4 py-4 text-[#878E99]  transition-all duration-200 border-2 border-black rounded-md bg-[#191B1E]  focus:border-[#ff014f] focus:bg-[#191B1E] " required />
                                        </div>
                                    </div>

                                    <div className='sm:col-span-2'>
                                        <label htmlFor="email" className="text-base font-medium text-[#878E99]"> Your email </label>
                                        <div className="mt-2.5 relative">
                                            <input type="email" name="email" id="email" placeholder="" className="block w-full px-4 py-4 text-[#878E99]  transition-all duration-200 border-2 border-black rounded-md bg-[#191B1E]  focus:border-[#ff014f] focus:bg-[#191B1E] " required />
                                        </div>
                                    </div>

                                    <div className='sm:col-span-2'>
                                        <label htmlFor="subject" className="text-base font-medium text-[#878E99]"> Subject </label>
                                        <div className="mt-2.5 relative">
                                            <input type="text" name="subject" id="subject" placeholder="" className="block w-full px-4 py-4 text-[#878E99]  transition-all duration-200 border-2 border-black rounded-md bg-[#191B1E]  focus:border-[#ff014f] focus:bg-[#191B1E] " required />
                                        </div>
                                    </div>

                                    <div className="sm:col-span-2">
                                        <label htmlFor="message" className="text-base font-medium text-[#878E99]"> Message </label>
                                        <div className="mt-2.5 relative">
                                            <textarea
                                                name="message"
                                                id="message"
                                                placeholder=""
                                                className="block w-full px-4 py-4 text-[#878E99]  transition-all duration-200 border-2 border-black rounded-md bg-[#191B1E]  focus:border-[#ff014f] focus:bg-[#191B1E] "
                                                rows="4"
                                                required
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div className="sm:col-span-2">
                                        <button type="submit" className="inline-flex items-center justify-center w-full px-4 py-4 mt-2 text-[#878E99] font-semibold border-2 border-black text-white transition-all duration-200 bg-[#191B1E] border border-transparent rounded-md focus:outline-none hover:bg-[#191B1E] focus:bg-[#191B1E]">
                                            Send
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </section>
                </div>
            </div>
            <div className="divider mt-20"></div>
        </div>
    )
}

export default ContactSection
